module.exports = __webpack_public_path__ + "img/cta.3d910ac5.jpg";